var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34658 16.6664C5.97366 16.6664 5.65602 16.5353 5.39366 16.2731C5.13144 16.0107 5.00033 15.6931 5.00033 15.3202V4.99977H4.16699V4.16643H7.50033V3.52539H12.5003V4.16643H15.8337V4.99977H15.0003V15.3202C15.0003 15.7038 14.8719 16.0241 14.6149 16.281C14.358 16.538 14.0377 16.6664 13.6541 16.6664H6.34658ZM14.167 4.99977H5.83366V15.3202C5.83366 15.4698 5.88171 15.5927 5.97783 15.6889C6.07408 15.785 6.19699 15.8331 6.34658 15.8331H13.6541C13.7824 15.8331 13.9 15.7797 14.0068 15.6729C14.1136 15.5661 14.167 15.4485 14.167 15.3202V4.99977ZM8.17345 14.1664H9.00678V6.66643H8.17345V14.1664ZM10.9939 14.1664H11.8272V6.66643H10.9939V14.1664Z",
    fill: "#FF2424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.34a727f203f82633611c77ffceefbbb6.svg";
export { ForwardRef as ReactComponent };